import dayjs from "dayjs";
import { createUniqueId } from "tm-shared/utils";

import { PHOTO_NAME_DATE_FORMAT } from "@/constants/config/dateFormats";
import { photoStorage } from "@/Services/PhotoStorage";

const SEPARATOR = "/";

export const createUploadPhotoMeta = (marketId: string) => {
    const validDate = dayjs().format(PHOTO_NAME_DATE_FORMAT);
    const filename = `${createUniqueId()}.jpg`;

    return {
        filename,
        middlePath: validDate,
        url: [marketId, validDate, filename].join(SEPARATOR),
    };
};

export const parseUploadedUrl = (uploadedUrl: string) => {
    const parts = uploadedUrl.split(SEPARATOR);

    if (parts.length < 3) return null;

    const [marketId, middlePath, filename] = parts;
    return { marketId, middlePath, filename };
};

export const getUploadPhotoMeta = async ({
    marketId,
    skipUpload,
}: {
    marketId: string;
    skipUpload: boolean;
}) => {
    if (!skipUpload) {
        const photoSlot = await photoStorage.getSlotAndDelete(marketId);
        if (photoSlot) return { ...photoSlot, fromSlot: true as const };
    }

    const meta = createUploadPhotoMeta(marketId);

    return { ...meta, fromSlot: false as const };
};
